import {useEventListener} from '../../../hooks/useEventListener';

export const useWindowResizeListener = (listener: (event: UIEvent) => any) => {
  useEventListener(window, 'resize', listener);
};
